/**
 * @imports third party packages
 * */
import React, { FC, ReactNode } from 'react';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
/**
 * @import internal components
 * */
import store from '@/store';
import Routers from '@/config/Routes/routes';
/**
 * @import css files
 * */
import './App.css';
import ThemeProvider from '@/context/theme';
import { AuthProvider } from '@/context/auth';
import ToastProvider from './components/organism/Toast/ToastProvider';
import { DateFilterContextProvider } from './context/dateFilter.context';

const App: FC = () => {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <HashRouter
          basename="/"
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <ToastProvider>
            <DateFilterContextProvider>
              <AuthProvider>
                <Routers />
              </AuthProvider>
            </DateFilterContextProvider>
          </ToastProvider>
        </HashRouter>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
